<template>
    <!-- <AppLayout :title="title"> -->
        <div class="d-flex justify-center">
            <div class="w-50rem max-w-100">
                <form @submit.prevent="manageUser">
                    <v-card>
                        <v-card-text>
                            <div class="d-flex flex-column ga-5">
                                <div class="fs-2 fw-medium pb-2">
                                    Admin Information
                                </div>
                                <div v-if="userForm.errors.custom_error" class="fs-1 pb-2 text-error">
                                    {{ userForm.errors.custom_error }}
                                </div>
                                <div>
                                    <v-text-field-v1
                                        label="Name"
                                        v-model="userForm.name"
                                        placeholder=""
                                        :error-messages="userForm.errors.name"
                                    ></v-text-field-v1>
                                </div>
                                <div>
                                    <v-text-field-v1
                                        label="Email"
                                        v-model="userForm.email"
                                        placeholder=""
                                        :error-messages="userForm.errors.email"
                                    ></v-text-field-v1>
                                </div>
                                <div class="d-flex flex-column ga-3">
                                    <div v-if="!creating">
                                        <v-switch-v1
                                            v-model="userForm.password_present"
                                            label="Change Password"
                                            ></v-switch-v1>
                                    </div>
                                    <div v-if="userForm.password_present">
                                        <v-text-field-v1
                                            label="Password"
                                            v-model="userForm.password"
                                            placeholder=""
                                            :error-messages="userForm.errors.password"
                                        ></v-text-field-v1>
                                    </div>
                                </div>
                                <div>
                                    <v-select-v1
                                        label="Biller"
                                        v-model="userForm.biller"
                                        :items="page.props.data?.billers"
                                        item-title="name"
                                        item-value="id"
                                        :error-messages="userForm.errors.biller"
                                    >
                                        <template v-slot:item="{ props, item }">
                                            <v-list-item v-bind="props" :title="null">
                                                <div class="fs-n1">{{ item.raw.name }}</div>
                                            </v-list-item>
                                        </template>
                                    </v-select-v1>
                                </div>
                                <div>
                                    <v-select-v1
                                        label="Bank Account"
                                        v-model="userForm.bank_account"
                                        :items="page.props.data?.bank_accounts"
                                        item-title="nickname"
                                        item-value="id"
                                        :error-messages="userForm.errors.bank_account"
                                    >
                                        <template v-slot:item="{ props, item }">
                                            <v-list-item v-bind="props" :title="null">
                                                <div class="fs-n1">{{ item.raw.nickname }}</div>
                                            </v-list-item>
                                        </template>
                                    </v-select-v1>
                                </div>
                                <div class="d-none">
                                    <v-text-field-v1
                                        label="Referer"
                                        v-model="userForm.success_redirect"
                                        placeholder=""
                                        :error-messages="userForm.errors.success_redirect"
                                    ></v-text-field-v1>
                                </div>
                            </div>
                        </v-card-text>
                        <v-card-actions-form>
                            <div class="d-flex flex-grow-1 justify-space-between">
                                <v-btn-input-compact color="btn-secondary"  @click="helpers.goBack">
                                    <template #prepend>
                                        <mdi-icon>chevron_left</mdi-icon>
                                    </template>
                                    Back
                                </v-btn-input-compact>
                                <v-btn-input-compact type="submit" :disabled="userForm.processing" :loading="userForm.processing">
                                    <template #prepend>
                                        <mdi-icon>check</mdi-icon>
                                    </template>
                                    <span v-if="creating">Create</span>
                                    <span v-else>Update</span>
                                </v-btn-input-compact>
                            </div>
                            
                        </v-card-actions-form>
                    </v-card>
            
                </form>
            </div>
        </div>
    <!-- </AppLayout> -->
 </template>
 <script setup lang="ts">
     import { ref } from "vue";
     import { useForm, usePage } from '@inertiajs/vue3';
     import { toast } from 'vue3-toastify';
     import { SharedPage, SharedPageProps } from '@/Types/inertia';
     import { User } from '@/Types/Models/user';
     import { Biller } from '@/Types/Models/biller';
     import { BankAccount } from '@/Types/Models/bank-account';
     import helpers from '@/Plugins/helpers';
     import { pageTitle, containerGapForForm } from '@/Composables/PageMeta';
 
     containerGapForForm();
     interface PageData extends SharedPageProps{
         data?:{
             user?: User,
             billers?: Biller[],
             bank_accounts?: BankAccount[],
             success_redirect?: String,
         }
     }
 
     interface UserForm{
        custom_error: string,
        id: number,
        name: string,
        email: string,
        password_present: boolean,
        password: string,
        biller: number | null,
        bank_account: number | null,
        success_redirect: String,
     }
 
     
     const page = usePage<PageData>();
     const creating = ref<boolean>( page.props?.data?.user?.id ? false : true);
     pageTitle.value = `${creating.value ? 'Create' : 'Update'} Admin`;
     const userForm = useForm<UserForm>({
        custom_error: '',
        id:  page.props?.data?.user?.id ?? 0,
        name:  page.props?.data?.user?.name ?? '',
        email:  page.props?.data?.user?.email ?? '',
        password_present:  creating.value ? true : false,
        password:  '',
        biller:  page.props?.data?.user?.biller_id ?? null,
        bank_account:  page.props?.data?.user?.bank_account_id ?? null,
        success_redirect: page.props.data?.success_redirect ?? '' as string
     });
 
     const manageUser = () => {
        userForm.post(route('admins.store', userForm.id), {
            onSuccess: (page: SharedPage) => {
                // console.log('page onSuccess', page);
                userForm.reset();
                toast.success(page.props?.jetstream?.flash?.msg?.text ?? 'Admin saved successfully');
            },
            onFinish: (visit) => {
                // console.log('visit onFinish', visit);
            },
            onError: (errors) => {
                console.log('onError', errors);
            }
        });
     };
 
     const sampleToast = () => {
        toast.success('Test toast');
     }
 </script>